/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import ChangeLog from './EUFEMIA_CHANGELOG.mdx';
import ReleasesInfo from './design-system/changelog/info-about-releases';
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    hr: "hr"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h1, {
      children: "Change log of Eufemia"
    }), "\n", _jsx(ReleasesInfo, {}), "\n", _jsx(_components.hr, {}), "\n", _jsx(ChangeLog, {})]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
